<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRelatorioExportacao',
    componentOptions: {
        title: 'Relatorio Exportacao',
        actions: [
            [
                {
                    name: 'Relatorio Exportacao',
                    iconClass: 'lyra-icon relatorio-rastreabilidade',
                    showView: false,
                    action: 'abrirRelatorioExportacao',
                    route: 'RelatorioExportacao',
                    nameTranslationKey: 'mensagens.menuLateral.relatorioExportacao'
                }
            ]
        ]
    },

    methods: {
        abrirRelatorioExportacao() {
            if (this.$route.name !== 'RelatorioExportacao') {
                this.$router.push({ name: 'RelatorioExportacao' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
